/* NanWasHere v3.1 navigation polish
   Keeps the primary navigation reachable on long product/collection pages without
   relying on the legacy theme sticky-header plugin. */
(function () {
  'use strict';

  function initNanPinnedHeader() {
    var desktopHeader = document.getElementById('header');
    var mobileHeader = document.getElementById('mobile-header');
    if (!desktopHeader && !mobileHeader) return;

    var activeHeader = null;
    var spacer = document.createElement('div');
    spacer.className = 'nan-header-spacer';
    var triggerY = 0;
    var ticking = false;

    function visibleHeader() {
      return window.matchMedia('(max-width: 798px)').matches ? mobileHeader : desktopHeader;
    }

    function unpin(header) {
      if (!header) return;
      header.classList.remove('nan-pinned-header');
      if (spacer.parentNode) spacer.parentNode.removeChild(spacer);
      spacer.style.height = '0px';
    }

    function measure() {
      unpin(activeHeader);
      activeHeader = visibleHeader();
      if (!activeHeader) return;
      var rect = activeHeader.getBoundingClientRect();
      triggerY = rect.top + window.pageYOffset;
      update();
    }

    function update() {
      ticking = false;
      if (!activeHeader) return;

      if (window.pageYOffset > triggerY) {
        if (!activeHeader.classList.contains('nan-pinned-header')) {
          spacer.style.height = activeHeader.offsetHeight + 'px';
          activeHeader.parentNode.insertBefore(spacer, activeHeader);
          activeHeader.classList.add('nan-pinned-header');
        }
      } else {
        unpin(activeHeader);
      }
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      window.clearTimeout(window.__nanHeaderResize);
      window.__nanHeaderResize = window.setTimeout(measure, 120);
    });

    document.addEventListener('shopify:section:load', measure);
    measure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNanPinnedHeader);
  } else {
    initNanPinnedHeader();
  }

  // Collection view controls hot-reload the product grid. Reconnect the legacy
  // infinite-scroll engine after that replacement so continuous browsing persists.
  document.addEventListener('list:hot-reload:updated', function () {
    window.requestAnimationFrame(function () {
      if (window.PXUTheme && window.PXUTheme.infiniteScroll && typeof window.PXUTheme.infiniteScroll.init === 'function') {
        window.PXUTheme.infiniteScroll.init();
      }
    });
  });

})();
